import React from 'react'

import {
  QuestionTreeViewBoxInner,
  type QuestionTreeViewBoxInnerProps,
} from '~/components/features/QuestionTreeViewBox/QuestionTreeViewBoxInner'
import { useLogEvent } from '~/hooks/useLogEvent'
import { type Question } from '~/hooks/useSurveyQuery'

type QuestionSelectionBoxProps = {
  // QuestionTreeViewBoxInner側の汎用ログ('Select question')に加えて、
  // タクソノミが役割別に区別している設問選択を個別イベントとして記録するための名前。
  logEventName: string
  onChange: (questionId: Question['question_id'] | null) => void
  questions: Question[]
  value: Question['question_id'] | null
}

export const QuestionSelectionBox = ({
  logEventName,
  onChange,
  questions,
  value,
}: QuestionSelectionBoxProps) => {
  const logEvent = useLogEvent()
  const selectedQuestionIds = React.useMemo(
    () => (value !== null ? [value] : []),
    [value],
  )

  const handleSelectedQuestionIdChange = React.useCallback<
    EH<QuestionTreeViewBoxInnerProps<Question>, 'onSelectedQuestionIdChange'>
  >(
    (questionIds) => {
      // 新しく追加されたIDを取得
      const addedIds = questionIds.filter((id) => id !== value)

      if (addedIds.length === 1) {
        // 子設問を1つクリックした場合 → その設問に入れ替え
        onChange(addedIds[0])
        logEvent(logEventName)
      } else if (addedIds.length > 1) {
        // 親設問クリックで複数の子IDが来た場合 → 無視
        return
      } else {
        // 選択済みの設問を削除した場合
        onChange(null)
      }
    },
    [logEvent, logEventName, onChange, value],
  )

  return (
    <QuestionTreeViewBoxInner
      questions={questions}
      selectedQuestionIds={selectedQuestionIds}
      onSelectedQuestionIdChange={handleSelectedQuestionIdChange}
    />
  )
}
